import React, { useState } from 'react';
import {
    Button, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row,
    Card, Table, CardSubtitle
} from 'reactstrap';
import { nameID, nameadd, sociall, rfcf, defaut, referenceLaboratories, save, cancell } from '../../constant';
import Select from 'react-select';

export const UpdateExamMicrobiology = (props) => {


    const { formValues, closeDialog, handleInputChange, validaciones, loading,
        sections, formats, changeSelect, specimenOrigins, specimens, specimenProvenances, subSections, transports,
        id_section, id_format_sanitary, id_subsection, id_specimen_origin,
        code, alias, name, abbreviation, individual_sale, is_referenced, is_critic, use_antibiogram,
        listExternalLaboratories, examId,
        getUpdateDefaultExternalLaboratory, methodAction, handleSelectValues, print_new_page
    } = props;

    //console.log(props, "propss")

    const {
        code: validationCode,
        alias: validationAlias,
        name: validationName,
        abbreviation: validationAbbreviation,
        id_section: validationSection,
        id_specimen: validationSpecimen,
        id_specimen_provenance: validateSpecimenProvenance,
        delivery_time: validateDeliveryTime,
        list_transports: validationListTransports,
        id_format_sanitary: validationFormat
    } = validaciones;
    const txtsection = localStorage.getItem('TextAS');

    const sectionOptions = sections.map(s => ({
        value: s.id_section,
        label: s.name
    }));

    const formatOptions = formats.map(s => ({
        value: s.id_format_sanitary,
        label: s.descripcion
    }));


    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Clave<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="text"
                        name="code"
                        value={code}
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationCode}
                    />
                    <FormFeedback>El codigo debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Alias <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="text"
                        name="alias"
                        value={alias}
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAlias}
                    />
                    <FormFeedback>El alias debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Abreviatura <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="text"
                        name="abbreviation"
                        value={abbreviation}
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAbbreviation}
                    />
                    <FormFeedback>La abreviatura debe tener 2 o más caracteres</FormFeedback>
                </FormGroup>
                </Row>
                <Row>
                    <FormGroup className="mb-3 col-6">
                        <Label className='labelInfoAnalyte'>Nombre del exámen <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            type="text"
                            name="name"
                            value={name}
                            required={true}
                            autoComplete="off"
                            onChange={handleInputChange}
                            invalid={validationName}
                        />
                        <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                     <FormGroup className="mb-3 col-6">
                        <Label className='labelInfoAnalyte'>Tiempo de entrega<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            value={formValues.delivery_time}
                            type="text"
                            name="delivery_time"
                            required={true}
                            autoComplete="off"
                            onChange={handleInputChange}
                            invalid={validateDeliveryTime}
                            
                        />
                        <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>

                </Row> <br />
                <Row>

                    {/* <FormGroup className="mb-3 col-4">
                        <Label>Subsección</Label> <br />
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            type="select"
                            name="id_subsection"
                            required={true}
                            onChange={handleInputChange}
                            value={id_subsection}
                        >
                            <option value={0}>Selecciona una opción</option>
                            {
                                subSections.length > 0 && subSections.map((ss, key) => {
                                    return <option
                                        key={key} value={ss.id_subsection}
                                    >
                                        {ss.name}
                                    </option>
                                })
                            }
                        </Input>
                    </FormGroup> */}
                    <FormGroup className="mb-3 col-4">
                        <Label className='labelInfoAnalyte'>{txtsection} <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Select
                            name="id_section"
                            options={sectionOptions}
                            value={sectionOptions.find(
                                opt => String(opt.value) === String(formValues.id_section)
                            )}
                            onChange={(e) => handleSelectValues(e.value, "id_section")}
                            isClearable={false}
                            classNamePrefix="select"
                            className={validationSection ? "is-invalid" : ""}
                            placeholder="Seleccione una sección"
                        />
                        {validationSection && (
                            <div className="invalid-feedback d-block">
                                Debes seleccionar al menos una opción
                            </div>
                        )}
                        
                    </FormGroup>
                    <FormGroup className="mb-3 col-4">
                        <Label className='labelInfoAnalyte'>Tipo de muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>

                        <Select
                            value={formValues.id_specimen}
                            classNamePrefix="select"
                            name="id_specimen"
                            placeholder={`Selección de especimen`}
                            isClearable={false}
                            noOptionsMessage={() => "Sin opciones"}
                            options={specimens}
                            onChange={(e) => handleSelectValues(e, "id_specimen")}
                        />
                        <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-4">
                        <Label className='labelInfoAnalyte'>Procedencia de la muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Select
                            value={formValues.id_specimen_provenance}
                            classNamePrefix="select"
                            name="id_specimen_provenance"
                            placeholder={`Seleciona la procedencia`}
                            isClearable={false}
                            noOptionsMessage={() => "Sin opciones"}
                            options={specimenProvenances}
                            onChange={(e) => handleSelectValues(e, "id_specimen_provenance")}
                        />
                        <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                    </FormGroup>
                    
                    <FormGroup className="mb-3 col-8">
                        <Label className='labelInfoAnalyte'>Medio(s) de transporte <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Select
                            value={formValues.list_transports}
                            isMulti
                            classNamePrefix="select"
                            name="list_transports"
                            onChange={(e) => handleSelectValues(e, "list_transports")}
                            // value={valuePeriod}
                            placeholder={`Selección de medio de transporte`}
                            isClearable={false}
                            noOptionsMessage={() => "Sin opciones"}
                            options={transports}
                            menuPortalTarget={document.body}
                             styles={{
                                    menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999999,
                                }),
                            }}

                        />
                        <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                    </FormGroup>

                    <FormGroup className="mb-3 col-4">
                        <Label className='labelInfoAnalyte'>Diseño de impresión <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>                   
                        <Select
                            name="id_format_sanitary"
                            options={formatOptions}
                            value={formatOptions.find(
                                opt => String(opt.value) === String(formValues.id_format_sanitary)
                            )}
                            onChange={(e) => handleSelectValues(e.value, "id_format_sanitary")}
                            isClearable={false}
                            classNamePrefix="select"
                            placeholder="Seleccione un diseño"
                        />

                        {validationFormat && (
                            <div className="invalid-feedback d-block">
                                Debes seleccionar un diseño de impresión
                            </div>
                        )}     
                </FormGroup>
                </Row>
                <Row>



                </Row>
                <Row>
                    <FormGroup className="mb-3 col-2 mb-3" style={{ "text-align": "center" }} >
                        <br />
                        <Label>Venta individual</Label>
                        <br />
                        <Label className="switch">
                            <Input type="checkbox" name="individual_sale" onChange={handleInputChange} checked={individual_sale} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>
                    <FormGroup className="mb-3 col-2 mb-3" style={{ "text-align": "center" }}    >
                        <br />
                        <Label>¿Es referenciado?</Label>
                        <br />
                        <Label className="switch">
                            <Input type="checkbox" name="is_referenced" onChange={handleInputChange} checked={is_referenced} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>
                    <FormGroup className="mb-3 col-2 mb-3" style={{ "text-align": "center" }}    >
                        <br />
                        <Label>¿Es crítico?</Label>
                        <br />
                        <Label className="switch">
                            <Input type="checkbox" name="is_critic" onChange={handleInputChange} checked={is_critic} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>

                     <FormGroup className="mb-3 col-3 mb-3" style={{ "text-align": "center" }} >
                          <br />
                        <Label>¿usa antibiograma?</Label>
                        <br />
                        <Label className="switch">
                    
                            <Input type="checkbox" name="use_antibiogram" onChange={handleInputChange} checked={use_antibiogram} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>
                    <FormGroup className="mb-3 col-3 mb-3" style={{ "text-align": "center" }} >
                        <br />
                        <Label>¿Impresión en una hoja diferente?</Label>
                        <br />
                        <Label className="switch">
                  
                            <Input type="checkbox" name="print_new_page" onChange={handleInputChange} checked={print_new_page} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>

                </Row>
                <Row>

               


            </Row>
            {/* </Card> */}
            {
                ////console.log(listExternalLaboratories)
            }
            <div className={listExternalLaboratories !== null && listExternalLaboratories.length >= 1 && is_referenced ? 'table-responsive' : 'd-none'} >
                <br />
                <CardSubtitle tag="h6" className="mb-2 text-muted">{referenceLaboratories}</CardSubtitle>
                <Table className="table table-sm">
                    <thead className="bg-light-primary text-center">
                        <tr className="border-bottom-primary">
                            <th style={{ "text-align": "-webkit-auto" }}>{nameID}</th>
                            <th style={{ "text-align": "-webkit-auto" }}>{nameadd}</th>
                            <th style={{ "text-align": "-webkit-auto" }}>{sociall}</th>
                            <th style={{ "text-align": "-webkit-auto" }}>{rfcf}</th>
                            <th style={{ "text-align": "-webkit-auto" }}>{defaut}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listExternalLaboratories !== null && listExternalLaboratories.length >= 1 && listExternalLaboratories.map((obj, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{ "text-align": "inherit" }}>{obj.code}</td>
                                        <td style={{ "text-align": "inherit" }}>{obj.name}</td>
                                        <td style={{ "text-align": "inherit" }}>{obj.business_name}</td>
                                        <td style={{ "text-align": "inherit" }}>{obj.rfc}</td>
                                        <td>
                                            <FormGroup check className="mb-3 col-5 offset-1">
                                                <Input type="radio" name="chek" checked={obj.is_default} onChange={() => getUpdateDefaultExternalLaboratory(examId, obj.id_external_laboratory)} />
                                            </FormGroup>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </div>
    {/* </Card> */}
            
            <ModalFooter>
                <Button
                    color="primary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {save}
                </Button>
                <Button color="danger" type="button" onClick={closeDialog}>{cancell}</Button>
            </ModalFooter>
        </Form>
    )
}
